import { create } from 'zustand';

export const useJsonStore = create<{
  genericObject: Record<string, any>; // or a more specific type
  setGenericObject: (state: Record<string, any>) => void;
}>((set) => ({
  genericObject: {}, // initial empty object
  setGenericObject: (state) => set({ genericObject: state }),
}));